<template>
    <div>
        <TopAppBar
            :leftBtnMode="leftBtnMode"
            :rightBtnMode="rightBtnMode"
            :title="title"
            :leftBtnMethod="leftBtnMethod"
            :rightBtnMethod="rightBtnMethod"
            staticMode="true"
        >
        </TopAppBar>

    <div id="tab1" class="t-color-content1 pdt-16 pdb-18">
        <div class="pdl-16 pdr-16 pdt-16px pdb-16px">
            <div>
                <button
                    class="t-helper t-color-white bg-dark d-inline-block mgr-4 pdt-5 pdb-4 pdl-4 pdr-4 b-radius2 l-spacing36
                    font-r">계정 관리</button>
                <button
                    class="t-helper t-color-white bg-blue1 d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 b-radius2 l-spacing36
                    font-r">로그인 또는 로그아웃</button>
            </div>
            <div class="t-headline7 t-color-title l-spacing6 pdt-10 pdb-8 font-m">온라인 강의는 어떻게 수료할 수 있나요?</div>
            <div class="t-body3 t-color-content1 l-spacing42 font-r">비밀번호 변경 또는 재설정은 어디서 할 수 있나요?<br>
            그리고 변경되는 현재 비밀번호를 잊어버렸을 때 할 수 있는
            조치도 알고 싶어요. 사용자의 문의 내용이 보여집니다.</div>
        </div>
        <!-- <div class="pdt-16"><img src="images/dummy_image.png" alt="" class="attachedImage"></div> -->

        <div class="mgb-60">
            <div class="pdl-16 pdr-16 pdb-8 pdt-8 t-helper t-color-content1 font-r font-11 commentDateTop shadow">등록일 : 2020.06.15</div>

            <div class="commentRoom pdt-16 pdb-24 pdl-16 pdr-16">
                <div class="commentSection">
                    <div class="commentInner">
                        <div class="d-flex">
                            <div class="userImage"><img src="images/helpdesk/ic_count.png" alt="" class="w-40 h-40 mgr-16"></div>
                            <div class="commentContent">
                                <div class="t-body3 t-color-title l-spacing42 font-r">홍길동1</div>
                                <div class="t-color-content1 t-helper">2020. 05. 25</div>
                                <div class="t-body3 t-color-content1 l-spacing42 font-r">안녕하세요. 문의하신 내용에 답변 드립니다. 비밀번호 재설정은 다음 경로에서 가능합니다.</div>

                                <div class="t-body2 t-color-red1 d-flex align-items-center pdt-16 pdb-8"><img src="images/helpdesk/chat.svg" alt=""
                                        class="w-18 h-18 d-inline-block mgr-8"> {{$t('1773')}}</div>
                            </div>
                        </div>

                        <div class="reply pdl-16 mgl-40 pdt-16">
                            <div class="d-flex">
                                <div class="userImage"><img src="images/helpdesk/ic_count.png" alt="" class="w-28 h-28 mgr-16"></div>
                                <div class="commentContent">
                                    <div class="t-body3 t-color-title l-spacing42 font-r">홍길동2</div>
                                    <div class="t-color-content1 t-helper">2020. 05. 26</div>
                                    <div class="t-body3 t-color-content1 l-spacing42 font-r">답변 감사합니다. 그런데 이 내용들도 알고 싶어요. 사용자가 등록한 답글 내용
                                    </div>
                        
                                    <div class="commentAttachmentImage d-flex">
                                        <img src="images/helpdesk/attachmentImage.png" alt="" class="max-w-80 max-h-80 b-radius4 mgr-8 mgt-8">
                                        <img src="images/helpdesk/attachmentImage.png" alt="" class="max-w-80 max-h-80 b-radius4 mgr-8 mgt-8">
                                    </div>

                                </div>
                            </div>
                            
                        </div>
                        



                    </div>
                </div>
            </div>

            <div class="textBlock w-full bg-white">
                <div class="divider"></div>
                <div class="pdl-16 pdr-16 pdt-13 pdb-4 d-flex ">
                    <div class="pdr-17"><i class="material-icons">collections</i></div>
                    <textarea name="" class="h-60 no-border t-body3 t-color-content1 l-spacing42 font-r"
                        placeholder="내용을 입력하세요"></textarea>
                    <span
                        class="material-icons sendMessage t-color-white w-24 h-24 align-items-center justify-content-between">arrow_upward</span>
                </div>
            </div>
            
        </div>
        

    </div>
    </div>
</template>

<script>
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '@/mixins/topAppBar.js'
export default {
    components: {
        TopAppBar,
    },

    mixins: [topAppBarMixin],

    watch: {
        '$route' (to, from) {
            
        }
    },

    mounted() {
        //this.setTopAppBarHomeBlank(this.$t('66'))
        this.setTopAppBarBackSearch(this.$t('1770'))
    },
}
</script>
<style scoped>
.nav-extended .brand-logo,
        .nav-content * {
            font-family: noto-regular;
        }

        .nav-extended .brand-logo {
            font-size: 20px;
            letter-spacing: -0.6;
        }

        .tabs .tab a:focus,
        .tabs .tab a:focus.active {
            background-color: #F5F5F5;
            outline: none;
        }

        .tabs .indicator {
            background: #2d6dcc;
        }

        .mdc-elevation--z3 {
            border-radius: 4px;
            box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
            background-color: #ffffff;
        }


        .b-radius2 {
            border-radius: 2px;
        }

        .l-spacing36 {
            letter-spacing: -0.36px;
        }

        .font-16 {
            font-size: 16px;
        }

        .bg-blue3 {
            background-color: #80aed4
        }
        .font-11{
            font-size: 11px;
        }
         .attachedImage{
            height: 356px;
            object-fit: cover;
        }
        .no-border{
            border:none;
            outline:none;
            box-shadow:none;
            width: 100%;
        }
        .commentDateTop.shadow{
            box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.26);
        }
        .sendMessage{
            background-color: #818181;
            border-radius: 50%;
            font-size: 18px;
            display: flex;
            justify-content: center;
            margin-left: 20px;
            min-width: 24px;
        }
        .textBlock{
            position: fixed;
            bottom: 0;
            left: 0;
        }
        .textBlock textarea{
            resize: none;
        }
        .textBlock textarea:focus + .sendMessage{
            background-color: #242f3b;
        }
   
        .commentAttachmentImage img{
            object-fit: cover;
        }
</style>